<template>
  <!-- PREHLED ZARIZENI -->
  <div class="list-page">
    <div v-if="project && project.projectId != 'undefined'">
      <div class="layout__content__header d-flex flex-column list-page__header layout__content__header--white">
        <CopyNotification
          :opened="copyConfirmVisible"
          :text="'zkopirovanoDoSchranky'"
          @close="copyConfirmVisible = false"
        />

        <div v-if="project" class="d-flex flex-wrap mb-4 mb-sm-0 justify-content-between">
          <h1 class="mb-1 mb-sm-4">
            {{ $t("MQTT_ZARIZENI") }}
          </h1>
        </div>

        <div class="d-flex">
          <DeviceSearch
            :filter-type="filterType"
            :project-id="projectId"
            :reload-items="reloadItems"
            :update-responsive-table="updateResponsiveTable"
            class="w-100"
            technology="mqtt"
            @search="search = $event"
            @all-projects="isSearchThroughAllProjects = $event"
            @set-filter-data="setFilterData"
          />
          <ImportDeviceButton />
        </div>
      </div>
      <div class="layout__content__header layout__content__header--white pt-0 pb-0">
        <RadioHelp
          :article-link="'/devices/mqtt'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <div v-if="radioSlides.length" class="detail-page__tabs__header d-flex">
        <div class="d-flex align-items-end detail-page__tabs__wrapper mt-5">
          <RadioOpenClose :radio-slides="radioSlides" :show="showHelp" @update-show-radio-help="showRadioHelp($event)" />
        </div>
      </div>
      <div v-if="allDevices && allDevices.length > 0" class="layout__content__content pt-4 pt-md-5">
        <DeviceListWarningBoxes technology="mqtt" @set-filter="setFilterData" />
        <div v-click-outside="closeDropdownActions" class="dropdown-actions">
          <button
            v-if="selectedRows.length > 0"
            class="btn btn-primary d-flex align-items-center"
            @click="showDropdownActions()"
          >
            {{ $t("hromadneAkce") }}
            <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
          </button>
          <button v-else class="btn btn-primary d-flex align-items-center" disabled>
            {{ $t("hromadneAkce") }}
            <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
          </button>
          <div
            v-if="isActionsDropdownVisible && selectedRows.length > 0"
            class="dropdown-actions__wrapper dropdown-actions__wrapper--wide"
          >
            <div class="dropdown-actions__inner">
              <div class="row">
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleDeleteDevice(selectedRows)
                      isActionsDropdownVisible = false
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-delete-l.svg" />
                  </div>
                  {{ $t("smazatZarizeni") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleMoveDeviceModal('moveDevice')
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/icon_move_orange.svg" />
                  </div>
                  {{ $t("MOVE_DEVICE") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="exportDevices('xlsx')"
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/icon_xlsx.svg" />
                  </div>
                  {{ $t("LABEL_EXPORT_XLSX") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                  @click="exportDevices('csv')"
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/icon_csv.svg" />
                  </div>
                  {{ $t("LABEL_EXPORT_CSV") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-end mb-md-4 mt-3 mt-md-0">
          <span class="font-weight-light">{{ $t("vybrano") }}: {{ selectedRows.length }}</span>
          <span v-if="selectedRows.length > 0" class="link ml-2" @click="selectAll('deselect')">
            {{ $t("OdvybratVse") }}
          </span>
        </div>

        <div class="position-relative w-100">
          <div id="mqtt" class="table-responsive">
            <table class="table table-main table-hover">
              <thead>
                <tr>
                  <th
                    v-for="(column, index) in columns"
                    :key="index"
                    :class="{ isHidden: !column.visible }"
                    :style="{ 'min-width': column.minWidth }"
                  >
                    <span v-if="column.sortable != true">
                      {{ $t(column.name) }}
                    </span>
                    <span v-else>
                      <div
                        v-if="column.name == 'custDeviceName'"
                        class="custom-control custom-control--checkbox"
                        :class="{ checked: allItemsSelected }"
                        @click="selectAll()"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>
                      <div class="title" @click="sortItemsBy(column.sortBy)">
                        {{ $t(column.name) }}
                      </div>
                      <div v-if="sortBy == column.sortBy" class="sorting">
                        <span v-if="sortType == 'desc'">▼</span>
                        <span v-if="sortType == 'asc'">▲</span>
                      </div>
                    </span>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_index) in allDevices" :key="item_index">
                  <td
                    v-for="(column, column_index) in columns"
                    :key="column_index"
                    :class="{
                      isHidden: !column.visible,
                      'grey-bg': item.suspended
                    }"
                    :style="{ width: column.minWidth }"
                  >
                    <span v-if="column.type == 'custDeviceName'">
                      <div
                        v-if="item.projectId == project.projectId"
                        :class="{
                          checked: selectedRows.filter((e) => e.deviceId === item.deviceId).length > 0
                        }"
                        class="custom-control custom-control--checkbox disabled"
                        style="display: inline-block"
                        @click="addToSelected(item)"
                      >
                        <input class="custom-control-input" disabled type="checkbox" />
                      </div>

                      <div
                        v-else
                        class="custom-control custom-control--checkbox disabled"
                        style="display: inline-block"
                      />
                      <RouterLink
                        :to="{
                          name: 'mqttDevice',
                          params: {
                            id: item.deviceId,
                            device: item,
                            customerId: item.customerId,
                            projectId: item.projectId
                          }
                        }"
                        class="font-weight-bolder link-gray"
                        @click="navigateToDetail(item)"
                      >
                        <span
                          :style="{
                            maxWidth: column.minWidth,
                            minWidth: column.minWidth
                          }"
                          style="display: block; word-wrap: break-word"
                        >
                          {{ item[column.type] }}
                        </span>
                      </RouterLink>
                    </span>
                    <span v-else-if="column.type == 'deviceId'">
                      <div v-tooltip :title="item.deviceId">
                        <span class="eui-short">
                          {{ $filters.strLimitEnd(item.deviceId, 6) }}
                        </span>
                        <span class="eui-full">{{ item.deviceId }}</span>
                      </div>
                      <div class="ml-2 copy d-flex align-items-center" @click="copyToClipboard(item.deviceId)">
                        <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                      </div>
                    </span>
                    <span v-else-if="column.type == 'topicIn'">
                      <div v-tooltip :title="getTopicIn(item.deviceId)">
                        <span class="eui-short">
                          {{ $filters.strLimitEnd(getTopicIn(item.deviceId), 6) }}
                        </span>
                        <span class="eui-full">
                          {{ getTopicIn(item.deviceId) }}
                        </span>
                      </div>
                      <div
                        class="ml-2 copy d-flex align-items-center"
                        @click="copyToClipboard(getTopicIn(item.deviceId))"
                      >
                        <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                      </div>
                    </span>
                    <div v-else-if="column.type == 'deviceGroups'">
                      <div
                        v-for="group in item.deviceGroups.slice(0, 1)"
                        :key="group.deviceGroupId + 'g' + item.deviceId"
                        class="d-flex"
                      >
                        <RouterLink
                          class="link-gray"
                          :to="{
                            name: 'group',
                            params: {
                              id: group.deviceGroupId,
                              projectId: group.projectId,
                              customerId: this.$route.params.customerId
                            }
                          }"
                        >
                          <span>
                            {{ $filters.strLimit(group.deviceGroupName, 25) }}
                          </span>
                        </RouterLink>
                        <div v-if="item.deviceGroups.length > 1" class="atom-expand" @click="toggleGroup(item)">
                          <span v-if="openedGroups.indexOf(item) > -1">-</span>
                          <span v-else>+</span>
                          {{ item.deviceGroups.length - 1 }}
                        </div>
                      </div>

                      <div v-if="openedGroups.indexOf(item) > -1" class="atom-expand__content d-flex flex-wrap">
                        <div
                          v-for="group in item.deviceGroups.slice(1, item.deviceGroups.length)"
                          :key="group.deviceGroupId + 'g' + item.device"
                          class=""
                        >
                          <a
                            class="link-gray"
                            @click="
                              $router.push({
                                name: 'group',
                                params: {
                                  id: group.deviceGroupId,
                                  group: group
                                }
                              })
                            "
                          >
                            <span>{{ group.deviceGroupName }}</span>
                          </a>
                        </div>
                      </div>

                      <div class="" />
                    </div>
                    <span v-else-if="column.type == 'status'">
                      <DeviceStatusIcon :device="item" />
                    </span>
                    <div v-else-if="column.type == 'tags'">
                      <TagBubbles :is-open="openedTags.includes(item)" :tag-list="item.tags" />
                    </div>

                    <span v-else-if="column.type == 'lastMessageIn'">
                      <span v-if="item.lastMessageIn != null">
                        {{ $t("pred") }}
                        {{ $filters.beforeTime(item.lastMessageIn, "short") }}
                      </span>
                    </span>

                    <span v-else-if="column.type == 'transformationLabel'">
                      {{ item.transformationLabel || $t("noTransformFunction") }}
                    </span>

                    <span v-else-if="column.type == 'provisionTime'">
                      {{ item.provisionTime }}
                    </span>

                    <span v-else-if="column.type == 'preregistrationEnd'">
                      {{ item.preregistrationEnd ? item.preregistrationEnd.toLocaleString() : "" }}
                    </span>

                    <span v-else>
                      {{ item[column.type] }}
                    </span>
                  </td>
                  <td>
                    <div
                      id="kebab"
                      ref="kebab"
                      :class="{
                        opened: openedDevice.deviceId == item.deviceId,
                        'grey-bg': item.suspended
                      }"
                      class="kebab"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <table :class="{ showShadow: showShadow }" class="table table-hover fixed-first-column">
              <thead>
                <tr>
                  <th>
                    <span v-if="columns[0].sortable != true">
                      {{ $t(columns[0].name) }}
                    </span>
                    <span v-else class="d-flex align-items-center">
                      <div
                        v-if="columns[0].name == 'custDeviceName'"
                        class="custom-control custom-control--checkbox"
                        :class="{ checked: allItemsSelected }"
                        @click="selectAll()"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>
                      <div class="title" @click="sortItemsBy(columns[0].sortBy)">
                        {{ $t(columns[0].name) }}
                      </div>
                      <div v-if="sortBy == columns[0].sortBy" class="sorting">
                        <span v-if="sortType == 'desc'">▼</span>
                        <span v-if="sortType == 'asc'">▲</span>
                      </div>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_index) in allDevices" :key="item_index">
                  <td :class="{ 'grey-bg': item.suspended }" :style="{ width: columns[0].minWidth }">
                    <span>
                      <div
                        v-if="item.projectId == project.projectId"
                        :class="{
                          checked: selectedRows.filter((e) => e.deviceId === item.deviceId).length > 0
                        }"
                        class="custom-control custom-control--checkbox"
                        style="display: inline-block"
                        @click="addToSelected(item)"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>
                      <div
                        v-else
                        class="custom-control custom-control--checkbox disabled"
                        style="display: inline-block"
                      />

                      <RouterLink
                        :to="{
                          name: 'mqttDevice',
                          params: {
                            id: item.deviceId,
                            device: item,
                            customerId: item.customerId,
                            projectId: item.projectId
                          }
                        }"
                        class="font-weight-bolder link-gray"
                        @click="navigateToDetail(item)"
                      >
                        <span
                          :style="{
                            maxWidth: columns[0].minWidth,
                            minWidth: columns[0].minWidth
                          }"
                          style="display: block; word-wrap: break-word"
                        >
                          {{ item.custDeviceName }}
                        </span>
                      </RouterLink>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <table :class="{ showShadow: showShadow }" class="table table-hover fixed-last-column">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_index) in allDevices" :key="item_index" :class="{ 'grey-bg': item.suspended }">
                  <td>
                    <div
                      id="kebab"
                      ref="kebab"
                      :class="{
                        opened: openedDevice.deviceId == item.deviceId
                      }"
                      class="kebab"
                    >
                      <div class="dropdown-actions">
                        <div class="atom-icon d-block mr-0" @click="openKebab(item)">
                          <img src="@/assets/icons/menu/ico-kebab.svg" />
                        </div>
                        <div
                          v-if="openedDevice.deviceId == item.deviceId"
                          v-click-outside="closeKebabConf"
                          class="dropdown-actions__wrapper"
                        >
                          <div class="dropdown-actions__inner">
                            <!--
                        <div
                          class="dropdown-actions__item d-flex align-items-center"
                        >
                          <router-link
                            :to="{
                              name: 'mqttDevice',
                              params: {
                                id: item.deviceId,
                                device: item,
                                customerId: customerId,
                                projectId: projectId
                              }
                            }"
                          >
                            {{ $t("detailZarizeni") }}
                          </router-link>
                        </div>-->
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              @click="
                                () => {
                                  actionItems = [openedDevice]
                                  toggleEditDeviceModal('editMqttDevice')
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" />
                              </div>
                              {{ $t("upravitZarizeni") }}
                            </div>
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              cols="6"
                              @click="
                                () => {
                                  actionItems = [openedDevice]
                                  toggleMoveDeviceModal('moveDevice')
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/icon_move_orange.svg" />
                              </div>
                              {{ $t("MOVE_DEVICE") }}
                            </div>
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              @click="
                                () => {
                                  actionItems = [openedDevice]
                                  toggleDeleteDevice([item])
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-delete-l.svg" />
                              </div>
                              {{ $t("odstranitZarizeni") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="itemsCount > 0" class="custom-table__footer w-100 d-flex align-items-center justify-content-between">
          <div class="custom-table__footer__actions align-items-center">
            <p class="link-gray mb-0" style="margin-right: 10px" @click="showSidebarTableColumnOrder = true">
              <span>{{ $t("upravitSloupce") }}</span>
            </p>
            <p v-if="!toggledAllRows" class="link-gray mb-0" @click="toggleAllRows()">
              <span>{{ $t("rozbalitVsechnyRadky") }}</span>
            </p>
            <p v-if="toggledAllRows" class="link-gray mb-0" @click="toggleAllRows()">
              <span>{{ $t("sbalitVsechnyRadky") }}</span>
            </p>
          </div>
          <Paging
            :page="{
              currentPage: page,
              rowsPerPage: rowsPerPage,
              itemsTotalCount: itemsCount,
              itemsCount: allDevices.length
            }"
            @page="page = $event"
            @next-page="page++"
            @prev-page="page--"
            @reload-items="reloadItems()"
            @rows-per-page="rowsPerPage = $event"
          />
        </div>
      </div>
      <div v-else-if="!loadingData" class="layout__content__content pt-4 pt-md-5">{{ $t("nicKZobrazeni") }}.</div>
      <div v-else class="layout__content__content pt-4 pt-md-5">
        <AppLoader />
      </div>
    </div>

    <div v-else>
      <div class="layout__content__header list-page__header">
        <div class="d-flex flex-wrap mb-4 mb-sm-0 justify-content-between">
          <h1 class="mb-1 mb-sm-4">
            {{ $t("zarizeni") }}
          </h1>
        </div>
      </div>
    </div>

    <DeleteDeviceModal
      :centered="true"
      :items="actionItems"
      :opened="openedDeleteDevice"
      :text="deleteText"
      @close="toggleDeleteDevice()"
      @yes="
        () => {
          deleteDevice()
          toggleDeleteDevice()
        }
      "
    />
    <!--
    <add-to-groups-modal
      :devices="actionItems"
      :opened="openedAddToGroups"
      @openBox="toggleAddToGroupsModal"
      @closeBox="toggleAddToGroupsModal"
      @reloadItems="reloadItems()"
    />
    <send-message
      :devices="actionItems"
      :opened="openedSendMessage"
      @openBox="toggleSendMessageModal"
      @closeBox="toggleSendMessageModal"
    />
    <add-tags
      :devices="actionItems"
      :opened="openedAddTags"
      @openBox="toggleAddTagsModal"
      @closeBox="toggleAddTagsModal"
    />
    <remove-tags
      :devices="actionItems"
      :opened="openedRemoveTags"
      @openBox="toggleRemoveTagsModal"
      @closeBox="toggleRemoveTagsModal"
    />
    <change-status-modal
      :devices="actionItems"
      :opened="openedChangeStatusModal"
      @openBox="toggleChangeStatusModal"
      @closeBox="toggleChangeStatusModal"
    />
    <change-service-modal
      v-if="actionItems[0]"
      :device="actionItems[0]"
      :opened="openedChangeServiceModal"
      @openBox="toggleChangeServiceModal"
      @closeBox="toggleChangeServiceModal"
    />
    <remove-from-groups-modal
      :devices="actionItems"
      :opened="openedRemoveFromGroups"
      @openBox="toggleRemoveFromGroupsModal"
      @closeBox="toggleRemoveFromGroupsModal"
      @reloadItems="reloadItems()"
    />
    <show-message
      :opened="openedMessageDetail"
      :device="deviceToShow"
      :item="messageToShow"
      @closeBox="toggleShowMessage"
    />-->
    <EditMqttDeviceModal
      v-if="openedEditDevice.length > 0"
      :device="actionItems[0]"
      :opened="openedEditDevice"
      :reload-attributes="reloadEditedDevice"
      :tags="tags"
      :transformations="transformations"
      @close-box="toggleEditDeviceModal"
      @open-box="toggleEditDeviceModal"
      @reload-items="reloadItems()"
    />
    <MoveDeviceModal
      v-if="openedMoveDevice.length > 0"
      :devices="actionItems"
      :opened="openedMoveDevice"
      @close-box="toggleMoveDeviceModal"
      @device-moved="reloadItems()"
      @open-box="toggleMoveDeviceModal"
    />
    <TableColumnOrder
      v-if="showSidebarTableColumnOrder"
      :columns="tableColumns"
      :columns-type="columnsTypeName"
      :opened="showSidebarTableColumnOrder"
      @close-box="closeSidebarTableColumnOrder()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>
<!-- push test -->

<script>
import _ from "lodash"
import Paging from "@/components/paging/paging.vue"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import DeleteDeviceModal from "@/components/confirmations/delete.vue"
//import AddToGroupsModal from "@/components/modals/devices/addToGroups.vue";
//import SendMessageModal from "@/components/modals/devices/sendMessage.vue";
//import AddTagsModal from "@/components/modals/devices/addTags.vue";
//import RemoveTagsModal from "@/components/modals/devices/removeTags.vue";
//import RemoveFromGroupsModal from "@/components/modals/devices/removeFromGroups.vue";
import EditMqttDeviceModal from "@/components/modals/devices/editMqtt.vue"
//import ChangeStatusModal from "@/components/modals/devices/changeStatus.vue";
//import ChangeServiceModal from "@/components/modals/devices/changeService.vue";
import TableColumnOrder from "@/components/modals/global/tableColumnOrder.vue"
//import ShowMessage from "@/components/modals/devices/messageShow.vue";
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import Notify from "@/components/notify/notify.vue"
import Loader from "@/components/loader.vue"
import MoveDeviceModal from "@/components/modals/devices/move.vue"
import DeviceSearch from "@/components/devices/partials/DeviceSearch.vue"
import { mapGetters } from "vuex"
import { exportDevices } from "@/plugins/exportDevices"
import DeviceListWarningBoxes from "@/components/devices/partials/ListWarningBoxes.vue"
import DeviceStatusIcon from "@/components/devices/partials/DeviceStatusIcon.vue"
import TagBubbles from "./tagBubbles.vue"
import FormSelect from "@/components/forms/FormSelect.vue"
import Import from "@/components/devices/import.vue"
import ImportDeviceButton from "@/components/devices/partials/ImportDeviceButton.vue"
import { useConfigStore } from "@/store/modules/config"
import { useProjectStore } from "@/store/modules/project"
import { useCustomerStore } from "@/store/modules/customer"
import { useMqttStore } from "@/store/modules/devices/mqtt"

export default {
  directives: {},
  components: {
    ImportDeviceButton,
    Import,
    FormSelect,
    DeviceStatusIcon,
    DeviceListWarningBoxes,
    DeviceSearch,
    Paging,
    DeleteDeviceModal,
    EditMqttDeviceModal,
    RadioHelp,
    RadioOpenClose,
    ErrorModal,
    CopyNotification: Notify,
    TableColumnOrder,
    AppLoader: Loader,
    MoveDeviceModal,
    TagBubbles
  },
  props: {},
  setup() {
    const projectStore = useProjectStore()
    const configStore = useConfigStore()
    const customerStore = useCustomerStore()
    const mqttStore = useMqttStore()

    return { projectStore, configStore, customerStore, mqttStore }
  },
  data() {
    return {
      radioSlides: [],
      showHelp: true,
      enabledExtendedSearch: false,
      tableWidth: 0,
      columns: [
        {
          type: "custDeviceName",
          name: "custDeviceName",
          sortable: true,
          sortBy: "custDeviceName",
          visible: true,
          minWidth: "250px",
          order: 1
        },
        {
          type: "status",
          name: "status",
          sortable: true,
          sortBy: "status",
          visible: true,
          minWidth: "100px",
          order: 2
        },
        {
          type: "deviceId",
          name: "idZarizeniMQTT",
          sortable: true,
          sortBy: "deviceId",
          visible: true,
          minWidth: "120px",
          order: 3
        },
        {
          type: "deviceGroups",
          name: "deviceGroups",
          sortable: false,
          visible: true,
          minWidth: "300px",
          order: 4
        },
        {
          type: "tags",
          name: "tags",
          sortable: false,
          visible: true,
          minWidth: "100px",
          order: 5
        },
        {
          type: "topicIn",
          name: "topicIn",
          sortable: false,
          visible: true,
          minWidth: "300px",
          order: 6
        },
        {
          type: "lastMessageIn",
          name: "lastMessageIn",
          sortable: true,
          sortBy: "lastMessageIn",
          visible: true,
          minWidth: "150px",
          order: 7
        },
        {
          type: "custServiceId",
          name: "custServiceId",
          sortable: false,
          visible: false,
          minWidth: "210px",
          order: 8
        },
        {
          type: "transformationLabel",
          name: "transformationLabel",
          sortable: false,
          visible: false,
          minWidth: "210px",
          order: 9
        },
        {
          type: "provisionTime",
          name: "PROVISION_TIME_LABEL",
          sortable: false,
          visible: false,
          minWidth: "210px",
          order: 10
        },
        {
          type: "preregistrationEnd",
          name: "PREREGISTRATION_END_LABEL",
          sortable: false,
          visible: false,
          minWidth: "210px",
          order: 11
        },
        {
          type: "preregistrationMsgsLeft",
          name: "PREREGISTRATION_MSG_LEFT_LABEL",
          sortable: false,
          visible: false,
          minWidth: "200px",
          order: 12
        }
      ],
      columnsTypeName: "columnsDevicesLora",
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId,
      search: "",
      isActionsDropdownVisible: false,
      sort: "custDeviceName",
      rowsPerPage: 20,
      page: 0,
      selectedRows: [],
      selectedAll: false,
      openedSideBox: false,
      openedDevice: {},
      transformations: {},
      openedGroups: [],
      openedTags: [],
      toggledAllRows: false,
      copyConfirmVisible: false,
      openedDeleteDevice: false,
      openedAddToGroups: [],
      openedRemoveFromGroups: [],
      openedChangeStatusModal: [],
      openedChangeServiceModal: [],
      deleteText: "",
      openedMessageDetail: [],
      deviceToShow: {},
      messageToShow: {},
      tags: [],
      openedAddTags: [],
      openedRemoveTags: [],
      openedSendMessage: [],
      openedEditDevice: [],
      actionItems: [],
      reloadEditedDevice: false,
      sortBy: "custDeviceName",
      sortType: "asc",
      loaded: false,
      loadingData: true,
      projectOnLoad: false,
      errorsToTranslate: [],
      openedError: false,
      closeKebabConf: {
        handler: this.closeKebab,
        middleware: this.middlewareKebab,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      },
      tableColumnsDefault: {
        status: {
          // status
          show: true,
          order: 2,
          title: "status"
        },
        deviceId: {
          // eui
          show: true,
          order: 3,
          title: "deviceId"
        },
        deviceGroups: {
          // groups
          show: true,
          order: 4,
          title: "deviceGroups"
        },
        topicIn: {
          show: true,
          order: 6,
          title: "topicIn"
        },
        tags: {
          // tags
          show: true,
          order: 5,
          title: "tags"
        },
        lastMessageIn: {
          // message
          show: true,
          order: 7,
          title: "lastMessageIn"
        },
        custServiceId: {
          show: false,
          order: 8,
          title: "custServiceId"
        },
        transformationLabel: {
          show: false,
          order: 9,
          title: "transformationLabel"
        },
        provisionTime: {
          show: false,
          order: 10,
          title: "PROVISION_TIME_LABEL"
        },
        preregistrationEnd: {
          show: false,
          order: 11,
          title: "PREREGISTRATION_END_LABEL"
        },
        preregistrationMsgsLeft: {
          show: false,
          order: 12,
          title: "PREREGISTRATION_MSG_LEFT_LABEL"
        }
      },
      showSidebarTableColumnOrder: false,
      tableColumns: {},
      showShadow: false,
      filterData: [],
      paramFilterData: [],
      openedMoveDevice: [],
      isSearchThroughAllProjects: false,
      projectIdsAndNames: [],
      filterType: [
        {
          name: "DEVICE_NAME",
          type: "custDeviceName",
          arrayValue: []
        },
        {
          name: "DEVICE_STATUS_IS",
          type: "status",
          arrayValue: []
        },
        {
          name: "IS_IN_GROUPS",
          type: "deviceGroupId",
          arrayValue: []
        },
        {
          name: "HAS_TAGS",
          type: "tags",
          arrayValue: []
        },
        {
          name: "SERVICE_IS",
          type: "custServiceId",
          arrayValue: []
        },
        {
          name: "deviceId",
          type: "deviceId",
          arrayValue: []
        },
        {
          name: "LAST_MESSAGE_IN",
          type: "lastMessageIn",
          arrayValue: []
        }
      ]
    }
  },
  computed: {
    allDevices() {
      return this.mqttStore.deviceList
    },
    itemsCount() {
      return this.mqttStore.totalCount
    },
    project() {
      return this.projectStore.selectedProject
    },
    projects() {
      return this.projectStore.projectList
    },
    customer() {
      return this.customerStore.selectedCustomer
    },
    customers() {
      return this.customerStore.customerList
    },
    allDevicesUnique() {
      let devices = this.allDevices
      let uniqed = _.uniqBy(devices, "deviceId")
      return uniqed
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    },
    allItemsSelected() {
      const selectedIds = this.selectedRows.map((row) => row.deviceId)
      for (const device of this.allDevices) {
        if (!selectedIds.includes(device.deviceId)) {
          return false
        }
      }
      return true
    }
  },
  watch: {
    project() {
      this.loadingData = true
      this.selectedRows = []

      if (!this.projectOnLoad) {
        this.loadDevices()
      }
    },
    rowsPerPage() {
      this.page = 0
      localStorage.rowsPerPage = this.rowsPerPage
    },
    radioDisabled() {
      this.showHelp = !this.radioDisabled
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.updateResponsiveTable)
      window.addEventListener("click", this.updateResponsiveTable)
    })
    this.showHelp = !this.radioDisabled

    if (localStorage.rowsPerPage) {
      this.rowsPerPage = localStorage.rowsPerPage
    } else {
      localStorage.rowsPerPage = this.rowsPerPage
    }

    if (this.project) {
      this.loadDevices()
      this.projectOnLoad = true
    }
    this.updateResponsiveTable()
  },
  methods: {
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    toggleExtendedSearch() {
      this.enabledExtendedSearch = !this.enabledExtendedSearch
    },
    updateResponsiveTable() {
      this.$updateResponsiveTable(this, "mqtt")
    },
    getTopicIn(deviceId) {
      return this.customerId + "." + this.projectId + ".in." + deviceId
    },
    /**
     * load all lora devices with actual search, sort and paging parameters
     */
    async loadDevices() {
      this.loadingData = true
      if (
        this.$route.params.notifications &&
        this.$route.params.notifications[0] &&
        this.$route.params.notifications[0].text
      ) {
        this.$store.commit("modals/setGlobalNotification", this.$route.params.notifications)
      }
      this.filterData = []
      if (this.isSearchThroughAllProjects) {
        const projectIdsAndNames = this.projects.reduce((result, project) => {
          result[project.projectId] = project.projectName
          return result
        }, {})
        this.projectIdsAndNames = projectIdsAndNames
      } else {
        this.filterData.push({
          field: "projectId",
          value: this.projectId
        })
        this.projectIdsAndNames[this.projectId] = this.project.projectName
      }
      if (this.paramFilterData.length) {
        let p = 0
        for (p = 0; p < this.paramFilterData.length; p++) {
          this.filterData.push({
            field: this.paramFilterData[p].name,
            value: this.paramFilterData[p].value,

            operator: this.paramFilterData[p].operator
          })
        }
      }
      const success = await this.mqttStore.getList({
        filters: this.filterData,
        search: this.search,
        sort: this.sort,
        sortType: this.sortType,
        rowsPerPage: this.rowsPerPage,
        currentPage: this.page
      })

      if (success) {
        this.loadingData = false
        this.$nextTick(() => {
          this.updateResponsiveTable()
        })
      }
    },
    reloadItems() {
      // this.selectedRows = [];
      this.loadDevices()
    },
    sortItemsBy(sortBy) {
      this.sortBy = sortBy
      if (this.sortType == "asc") {
        this.sortType = "desc"
      } else {
        this.sortType = "asc"
      }
      this.sort = new String(sortBy)
      this.reloadItems()
    },
    setFilterData(filterData) {
      this.paramFilterData = filterData
      this.page = 0

      this.reloadItems()
    },
    showDropdownActions() {
      this.isActionsDropdownVisible = !this.isActionsDropdownVisible
    },
    addToSelected(device) {
      if (this.selectedRows.filter((e) => e.deviceId === device.deviceId).length > 0) {
        const index = this.selectedRows.map((e) => e.deviceId).indexOf(device.deviceId)

        this.selectedRows.splice(index, 1)
      } else {
        this.selectedRows.push(device)
      }
    },
    selectAll(type) {
      if (type === "deselect") {
        this.selectedRows = []
        return
      }

      if (this.allItemsSelected) {
        const visibleDeviceIds = this.allDevices.map((device) => device.deviceId)
        this.selectedRows =this.selectedRows.filter((row) => !visibleDeviceIds.includes(row.deviceId))
      } else {
        this.selectedRows = this.selectedRows.concat(this.allDevices)
      }
    },
    openKebab(device) {
      this.openedDevice = this.openedDevice == device ? {} : device
    },
    copyToClipboard(text) {
      this.copyConfirmVisible = true
      var input = document.createElement("textarea")
      input.innerHTML = text
      document.body.appendChild(input)
      input.select()
      var result = document.execCommand("copy")
      document.body.removeChild(input)
      return result
    },
    toggleSideBox(box) {
      this.openedSideBox = box == false ? false : box
    },
    toggleGroup(device) {
      var index = this.openedGroups.indexOf(device)
      if (this.openedGroups.indexOf(device) > -1) {
        this.openedGroups.splice(index, 1)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedGroups.push(device)
      }
    },
    toggleTag(device) {
      var index = this.openedTags.indexOf(device)
      if (this.openedTags.indexOf(device) > -1) {
        this.openedTags.splice(index, 1)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedTags.push(device)
      }
    },
    toggleAllRows() {
      if (this.toggledAllRows) {
        this.openedTags = []
        this.openedGroups = []
        this.toggledAllRows = false
      } else {
        this.openedTags = [].concat.apply([], this.allDevices)
        this.openedGroups = [].concat.apply([], this.allDevices)
        this.toggledAllRows = true
      }
    },
    toggleEditDeviceModal(box) {
      if (this.openedEditDevice.indexOf(box) > -1) {
        box == undefined
          ? (this.openedEditDevice = [])
          : this.openedEditDevice.splice(this.openedEditDevice.indexOf(box), 1)

        this.selectedRows = []
        this.selectedAll = false
        if (box == undefined || box == "editMqttDevice") {
          this.openedDevice = {}
        }
      } else {
        this.openedEditDevice.push(box)
        if (box == "editMqttDevice") {
          this.reloadEditedDevice = true
          setTimeout(() => {
            this.reloadEditedDevice = false
          }, 1500)
        }
      }
    },
    closeDropdownActions() {
      this.isActionsDropdownVisible = false
    },
    closeKebab() {
      this.openedDevice = {}
    },
    middleware(event) {
      return event.target.className !== "kebab"
    },
    closeSidebarTableColumnOrder() {
      this.tableColumns = this.getTableColumns()
      this.showSidebarTableColumnOrder = false
      this.$updateTableContent(this)
    },
    getTableColumns() {
      const localStorageItemsJSON = localStorage.getItem(this.columnsTypeName)
      if (!localStorageItemsJSON) {
        return this.tableColumnsDefault
      }

      const localStorageItems = JSON.parse(localStorageItemsJSON)

      if (
        Object.keys(localStorageItems).length === 0 ||
        Object.keys(localStorageItems).length !== Object.keys(this.tableColumnsDefault).length
      ) {
        return this.tableColumnsDefault
      }
      return localStorageItems
    },
    async exportDevices(type) {
      this.errorsToTranslate = []
      this.$store.commit("modals/setWaitingLoader", this.$t("Exportuji data, čekejte prosím..."))
      const errors = await exportDevices(
        type,
        "mqtt",
        this.projectId,
        this.selectedRows.map((device) => device.deviceId)
      )
      this.$store.commit("modals/setWaitingLoader", "")
      if (errors?.length) {
        this.errorsToTranslate = errors
        this.openedError = true
      }
    },
    async deleteDevice() {
      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))

      let notifications = []
      let er = [{ errors: [] }]

      for (const item of this.actionItems) {
        try {
          await this.mqttStore.deleteDevice(item)

          notifications.push({
            text: "notificationDeviceDelete",
            error: false,
            params: {
              deviceId: item.deviceId,
              custDeviceName: item.custDeviceName
            }
          })
        } catch (e) {
          let message = e.data?.errors?.[0]
          er[0].errors.push({
            message: message,
            attribute: {
              deviceId: item.deviceId,
              custDeviceName: item.custDeviceName
            }
          })
        }
      }

      if (er[0].errors.length) {
        this.errorsToTranslate = er
        this.openedError = true
      }

      this.$store.commit("modals/setWaitingLoader", "")
      this.$store.commit("modals/setGlobalNotification", notifications)

      this.selectedRows = []
      this.loadDevices()
    },
    toggleDeleteDevice(items) {
      if (this.openedDeleteDevice) {
        this.openedDeleteDevice = false
        this.deleteText = ""
      } else {
        if (items) {
          this.deleteText = items.length > 1 ? "zarizeniPocet" : items[0].custDeviceName
        }
        this.openedDeleteDevice = true
      }
    },
    toggleMoveDeviceModal(box) {
      if (this.openedMoveDevice.indexOf(box) > -1) {
        box == undefined
          ? (this.openedMoveDevice = [])
          : this.openedMoveDevice.splice(this.openedMoveDevice.indexOf(box), 1)
      } else {
        this.openedMoveDevice.push(box)
      }
    },
    navigateToDetail(item) {
      let project = this.projects.find((i) => i.projectId == item.projectId)

      if (project.customerId !== this.customer.customerId) {
        let customer = this.customers.find((i) => i.customerId == project.customerId)
        this.customerStore.setCustomer(customer)
      }
      this.projectStore.setProject(project)

      this.$router.push({
        name: "mqttDevice",
        params: {
          id: item.deviceId,
          device: item,
          customerId: item.customerId,
          projectId: item.projectId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.eui-short {
  display: none;
}

.eui-full {
  display: block;
}

/*
  .shadowed .eui-short {
    display: block;
  }

  .shadowed .eui-full {
    display: none;
  }
  */
</style>
